<template>
  <div>
    <v-breadcrumbs class="px-0" :items="items"></v-breadcrumbs>
    <v-row>
      <v-col>
        <div v-if="worldCalendarById">
          <v-row>
            <v-col class="d-flex flex-1 align-center justify-space-between pb-5">
              <span class="header bold text-tcdc-green">{{worldCalendarById[`name_${lang}`]}}</span>
              <ShareButton mode="world-calendar" :title="worldCalendarById[`name_${lang}`]"></ShareButton>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <div class="pr-3 d-flex align-center">
                <img src="../../assets/icons/sorts/calendar.png" class="eventdetail-card-logo mr-4" />
                <span class="text-tcdc-green bold mr-4 text-uppercase">{{worldCalendarById[`event_date_${lang}`] | moment('DD MMM YYYY')}} - {{worldCalendarById[`end_event_date_${lang}`] | moment('DD MMM YYYY')}}</span>
              </div>
<!--              <img src="../../assets/icons/generals/view.png" class="tcdc-view-icon mr-2" />-->
<!--              <span class="text-tcdc-grey1 bold mr-4">{{formatNumber(worldCalendarById.article_view)}}</span>-->
            </v-col>
          </v-row>
          <!-- section 1 -->
          <v-row class="mb-5" v-if="worldCalendarById.image_show">
            <v-col>
              <v-img eager :src="worldCalendarById.image_show" width="100%"></v-img>
              <!--        <ImageCarousel />-->
            </v-col>
          </v-row>
          <v-row>
            <v-col class="pt-0">
              <div
                      class="text-tcdc-green bold vhtml"
                      v-html="worldCalendarById[`description_${lang}`].replace(/(\\r)*\\n/g, '<br>')"
              ></div>
            </v-col>
          </v-row>

          <!-- section relate article -->
<!--          <v-row class="pt-8">-->
<!--            <v-col>-->
<!--              <span class="text-tcdc-green sub-header1 bold text-uppercase">related article</span>-->
<!--            </v-col>-->
<!--          </v-row>-->
<!--          <v-row class="d-flex flex-wrap">-->
<!--            <template v-for="(item, index) of articles">-->
<!--              <v-col cols="12" md="6" :key="index">-->
<!--                &lt;!&ndash; <EventCard-->
<!--                  class="cursor-pointer"-->
<!--                  :name="item.name"-->
<!--                  :time_start="item.start_date"-->
<!--                  :time_end="item.end_date"-->
<!--                  :place="item.place"-->
<!--                  @click.native="eventDetailHandler"-->
<!--                />&ndash;&gt;-->
<!--                <ArticleCard :border="false" />-->
<!--              </v-col>-->
<!--            </template>-->
<!--          </v-row>-->
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapState } from "vuex";
import ShareButton from "../../components/buttons/ShareButton";
import {BreadcrumbUtil} from "@/util/BreadcrumbUtil";

export default {
  components: {
    ShareButton
  },
  async created() {
    this.items = BreadcrumbUtil.setServiceItem(
        this.items,
        this.branchId,
        this.branchName,
        this.allBranches,
        this.lang
    )
    await this.$store.dispatch('Program/onGetDesignWorldCalendarById', this.$route.params.id);
  },
  computed: {
    ...mapState({
      branchName: state => state.Branch.branch_name,
      allBranches: state => state.Branch.branches,
      branchId: state => state.Branch.branch_id,
      lang: state => state.Branch.lang,
      worldCalendarById: state => {
        if (state.Program.worldCalendarById) {
          return state.Program.worldCalendarById
        }
      },
    }),
    branchChanged: function () {
      return this.branchName;
    }
  },
  watch: {
    branchChanged: function() {
      this.items = BreadcrumbUtil.setServiceItem(
          this.items,
          this.branchId,
          this.branchName,
          this.allBranches,
          this.lang
      )
    }
  },
  data: () => ({
    item: {
      id: 1,
      layout: 1
    },
    items: [
      {
        text: 'TCDC BANGKOK',
        disabled: false,
        to: "/home/:branch"
      },
      {
        text: "SERVICE",
        disabled: false,
        to: "/:branch/service"
      },
      {
        text: "RESOURCE CENTER",
        disabled: false,
        href: "/:branch/service/resource-center"
      },
      {
        text: "DESIGN WORLD CALENDAR",
        disabled: false,
        href: "/:branch/service/resource-center/design-world-calendar"
      }
    ]
  })
};
</script>

<style>
  .eventdetail-card-logo {
    height: 25px;
    object-fit: contain;
  }
</style>
